import { useContext } from "react";
import TextEditor from "../../components/Table/TextEditor";
import { context } from "../../context/authContext";
import useActions from "./acciones";

export default function useColumns(setSelectedRow,setModalOpen,templates) {
  const { user } = useContext(context);
  const { handleDelete } = useActions();

  const userRoles = user?.rol || [];
  const permisos = userRoles.find((role) => role.nombre === "Productos")?.permiso || [];
  const isEditable = permisos.includes("editar");
  const canDelete = permisos.includes("borrar");

  let templateOptions = {};
  for(const template of templates){
    templateOptions[template.id] = template.nombre;
  }

  return [
    { field: "id", sort: "asc", cellClass: "d-flex align-items-center" },
    ...["id_woo","titulo","descripcion"].map((field) => ({
      field,
      flex: 2,
      cellClass: "d-flex align-items-center",
      cellEditor: TextEditor,
      editable: field === "createdAt" ? false : isEditable,
      valueFormatter: field === "createdAt" ? (params) =>{
        let date =  `${new Date(params.value).toLocaleDateString("en-GB")} 
        ${new Date(params.value).toLocaleTimeString("en-GB")}` 
        return date }: undefined,
      tooltipValueGetter: (params) => params.data?.[`tooltipError${field}`] || "",
      cellClassRules: {
        "is-invalid": (params) => !!params.data?.[`tooltipError${field}`],
        "is-valid": (params) => !!params.data?.[`isValid${field}`],
      },
      valueParser: (params) => {
        if(field === "id_woo"){
          const newValue = Number(params.newValue);
          return isNaN(newValue) ? null : newValue;
        }
      }
    })),
    {
      field: "template",
      flex: 2,
      autoHeight: true,
      cellClass: "d-flex align-items-center",
      cellEditor: "agSelectCellEditor",
      editable: (params) => params.data.rol !== "superadmin" && isEditable,
      cellEditorParams: { values: Object.keys(templateOptions) },
      valueFormatter: (params) => templateOptions[params.value] || params.value,
    },
    {
      field: "tipo",
      flex: 2,
      cellClass: "d-flex align-items-center",
      cellEditor: "agSelectCellEditor",
      editable: isEditable,
      cellEditorParams: { values: ['Platea','General','General+Bingo','Normal'] },
    },
    {
      field: "bingo",
      flex: 2,
      cellClass: "d-flex align-items-center",
      cellEditor: "agSelectCellEditor",
      editable: isEditable,
      cellEditorParams: { values: ['Si','No'] },
    },
    {
      field: "desde",
      flex: 2,
      cellClass: "d-flex align-items-center",
      cellEditor: TextEditor,
      editable: true,
      valueFormatter: (params) =>{
        let date =  `${new Date(params.value).toLocaleDateString("en-GB")} 
        ${new Date(params.value).toLocaleTimeString("en-GB")}` 
        return date 
      },
    },
    {
      field: "hasta",
      flex: 2,
      cellClass: "d-flex align-items-center",
      cellEditor: TextEditor,
      editable: true,
      valueFormatter: (params) =>{
        let date =  `${new Date(params.value).toLocaleDateString("en-GB")} 
        ${new Date(params.value).toLocaleTimeString("en-GB")}` 
        return date 
      },
    },
    {
      field: "createdAt",
      flex: 2,
      cellClass: "d-flex align-items-center",
      cellEditor: TextEditor,
      editable: false,
      valueFormatter: (params) =>{
        let date =  `${new Date(params.value).toLocaleDateString("en-GB")} 
        ${new Date(params.value).toLocaleTimeString("en-GB")}` 
        return date 
      },
    },
    canDelete && {
      field: "eliminar",
      flex: 2,
      cellClass: "d-flex align-items-center justify-content-center",
      cellRenderer: (data) => (
        <button onClick={() => handleDelete(data, setSelectedRow,setModalOpen)} className="btn btn-primary px-2 py-1">
          🗑️ Eliminar
        </button>
      ),
    },
  ].filter(Boolean);
}